import React, { useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav
} from "reactstrap";

import { AppNavbarBrand, AppSidebarToggler } from "@coreui/react";
import googleLogo from "../../assets/img/googleLogo.svg";
import oktaLogo from "../../assets/img/oktaLogo.svg";
import logo from "../../assets/img/brand/logoComsystoReply.svg";
import sygnet from "../../assets/img/brand/logoComsystoReplyRunner.svg";
import { isLoggedIn } from "../../services/userInfo";
import { ENDPOINT } from "../../config";
import { styles } from "../../views/GetTravelExpense/view/OrderStatusDropdown";

const DefaultHeader = () => {
  const delete_cookies = name => {
    document.cookie =
      name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    document.cookie =
      name +
      "=; Path=/; Domain=.travelexp-dev.comsysto.com; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    document.cookie =
      name +
      "=; Path=/; Domain=travelexp-dev.comsysto.com; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    document.cookie =
      name +
      "=; Path=/; Domain=.travelexp.comsysto.com;  Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    document.cookie =
      name +
      "=; Path=/; Domain=travelexp.comsysto.com;  Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  };
  const handleLogout = () => {
    delete_cookies("jwt");
    window.location.href = "/";
  };

  const handleLoginOkta = () => {
    window.location.href = ENDPOINT.LOGIN_OKTA;
  };
  const handleLoginGoogle = () => {
    window.location.href = ENDPOINT.LOGIN_GOOGLE;
  };
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen(prevState => !prevState);

  return (
    <React.Fragment>
      <AppSidebarToggler className="d-lg-none" display="md" mobile />
      <AppNavbarBrand
        full={{ src: logo, width: 89, height: 25, alt: "ComsystoReply Logo" }}
        minimized={{
          src: sygnet,
          width: 30,
          height: 30,
          alt: "ComsystoReply Logo"
        }}
      />
      <AppSidebarToggler className="d-md-down-none" display="lg" />

      <Nav className="ml-auto" navbar>
        {isLoggedIn() ? (
          <button onClick={handleLogout} className="btn btn-danger  mr-3">
            Logout
          </button>
        ) : (
          <Dropdown isOpen={dropdownOpen} toggle={toggle} className=" mr-3">
            <DropdownToggle caret style={styles.dropdownGeneral}>
              Login
            </DropdownToggle>
            <DropdownMenu flip={false}>
              <DropdownItem
                key="okta"
                className="d-flex flex-row justify-content-center align-items-center pl-0"
                onClick={handleLoginOkta}
              >
                <img src={oktaLogo} alt="OktaLogo" className="pr-1" />
                <div>Login with Okta</div>
              </DropdownItem>
              <DropdownItem
                key="google"
                className="d-flex flex-row justify-content-center align-items-center"
                onClick={handleLoginGoogle}
              >
                <img src={googleLogo} alt="GoogleLogo" className="pr-1" />
                <div>Login with Google</div>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        )}
      </Nav>
    </React.Fragment>
  );
};

export default DefaultHeader;
